// ==============================================
// ===================Imports====================
// ==============================================
// ==============================================

// =================ACTIONS=====================
import {
  SET_LOADING_HEADER,
  SET_OPEN_COMMAND_LINE_CLIENT_MODAL,
  SET_OPEN_HISTORY_MODAL,
  SET_OPEN_SAFARI_MODAL,
  SET_SAVE_DATA_HEADER,
  SET_SAVE_HTML_MODAL,
} from '../actions/header';

// ==============================================
// ================InitialState==================
// ==============================================

const initialState = {
  modal: {
    commandLineClientModal: false,
    historyModal: false,
    safariModal: false,
  },
  data: [],
  loadingHeader: true,
  htmlModal: '',
};

function headerReducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_OPEN_COMMAND_LINE_CLIENT_MODAL:
      return {
        ...state,
        modal: {
          ...state.modal,
          commandLineClientModal: action.value,
        },
      };
    case SET_OPEN_HISTORY_MODAL:
      return {
        ...state,
        modal: {
          ...state.modal,
          historyModal: action.value,
        },
      };
    case SET_SAVE_DATA_HEADER:
      return {
        ...state,
        data: action.value,
      };
    case SET_LOADING_HEADER:
      return {
        ...state,
        loadingHeader: action.value,
      };
    case SET_SAVE_HTML_MODAL:
      return {
        ...state,
        htmlModal: action.value,
      };
    case SET_OPEN_SAFARI_MODAL:
      return {
        ...state,
        modal: {
          ...state.modal,
          safariModal: action.value,
        },
      };
    default:
      return state;
  }
}

export default headerReducer;
